import axios from 'axios';
import { Platform } from 'quasar';
import actions from '../../lib/api/actions';

export function blockInteraction({ commit }) {
  commit('blockInteraction');
}

export function allowInteraction({ commit }) {
  commit('allowInteraction');
}

export async function fetchVersion({ commit }) {
  const response = await actions.fetchVersion();
  if (response.status === 200) {
    commit('updateVersion', { version: response.data });
  }
}

export async function fetchBackgroundImage({ commit }) {
  let response;
  if (process.env.NODE_ENV === 'development') {
    response = await axios.get('http://greifinn.dev.moya.is/_/moya/adverts/region/show/5');
  }
  else {
    response = await axios.get('https://www.greifinn.is/_/moya/adverts/region/show/5');
  }

  let url = '';

  if (response.status === 200) {
    if (response.data) {
      if (Platform.is.ipad) {
        url = response.data.url.replace('lg', 'md');
      }
      else if (Platform.is.mobile) {
        url = response.data.url.replace('lg', 'xs');
      }
      else {
        // eslint-disable-next-line prefer-destructuring
        url = response.data.url;
      }
      commit('updateBackgroundImage', url);
    }
  }
}
